(function ($) {
  let idleTimeCount = 1;
  let idleInterval;
  let idleTime;
  let idleClose;
  let screenTop;
  let windowWidth;
  const commBar = $('.component-communication-bar');
  const time = 1000; // 1 second

  const timerIncrement = () => {
    idleTimeCount += 1;

    if (idleTimeCount > (idleTime / 1000)) {
      $('.need-help').addClass('active');
      clearInterval(idleInterval);

      setTimeout(() => {
        $('.need-help').removeClass('active');
      }, idleClose);
    }
  };

  const needHelpNotification = function () {
    idleTime = ($('.need-help').data('idle') * time);
    idleClose = ($('.need-help').data('close') * time);

    // Increment the "idle time" counter every second.
    idleInterval = setInterval(timerIncrement, idleTime);

    // Clear the idle timer on mouse movement.
    $(window).mousemove(() => {
      idleTimeCount = 0;
    });

    $(window).keypress(() => {
      idleTimeCount = 0;
    });
  };

  const communicationBar = () => {
    // Stick the Communication Bar to the bottom of the page and unstick when scrolled past its vertical position

    let communicationBarPos = 0;

    $(commBar).addClass('affix');

    $(window).on('scroll', () => {
      if (commBar.length > 0) {
        const bottom = commBar.position().top + commBar.outerHeight(true);

        if (bottom === communicationBarPos && communicationBarPos != null) {
          commBar.removeClass('affix');
        } else {
          commBar.addClass('affix');
        }

        communicationBarPos = bottom;
      }
    });

    if ($(window).height() >= $(document).height()) {
      $(commBar).removeClass('affix'); // If page is shorter than the screen, un-affix footer from bottom
    }
  };

  const supportAndContact = () => {
    const button = $('.support-contact');
    const panel = $('#supportAndContact');
    const panelClose = $(panel).find('.close');

    button.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      windowWidth = $(window).width();

      // Stretch the icon's width to match design
      $('.feather-arrow-right').find('line').attr('x1', 0);

      $(button).blur();
      $(panelClose).focus();

      if (windowWidth <= 586) {
        $(commBar).addClass('active');
        $('body').addClass('noscroll');

        screenTop = $(document).scrollTop();

        $(panel).insertBefore('header');
        window.scrollTo(0, 0);
      }

      $(panel).addClass('active');
    });

    $(document).click((e) => {
      if ($(e.target).closest('#supportAndContact').length === 0) {
        $(commBar).removeClass('active');
        $(panel).removeClass('active');
      }
    });

    panelClose.on('click', (e) => {
      e.preventDefault();
      windowWidth = $(window).width();

      if (windowWidth <= 586) {
        $(panel).insertAfter('.support-contact');
        window.scrollTo(0, screenTop);
        $('body').removeClass('noscroll');
      }

      $(commBar).removeClass('active');
      $(panel).removeClass('active');
      $('body').removeClass('cb-open');
    });
  };

  const init = () => {
    communicationBar();
    needHelpNotification();
    supportAndContact();
  };

  $(init);
}(jQuery));
